import React from "react";
import {
  HiOutlineArrowCircleRight as PaginationRightIcon,
  HiOutlineArrowCircleLeft as PaginationLeftIcon,
} from "react-icons/hi";
import * as tools from "../../utils/tools";

const PaginationFooterRising = ({
  currentPage,
  totalPages,
  getAllList,
}: any) => {
  const seeMore = (e: any) => {
    e.preventDefault();
    console.log("currentPage:", currentPage);
    getAllList();
  };
  const seePrevious = (e: any) => {
    e.preventDefault();
    console.log("currentPage:", currentPage);
    getAllList(false);
  };
  return (
    <>
      <div>
        {currentPage > 1 && (
          <>
            <a href="#" onClick={seePrevious}>
              <PaginationLeftIcon style={{ width: "32px", height: "32px" }} />
            </a>
          </>
        )}
        {currentPage < totalPages && (
          <>
            <a href="#" onClick={seeMore}>
              <PaginationRightIcon style={{ width: "32px", height: "32px" }} />
            </a>
          </>
        )}
      </div>
      {totalPages > 1 && <div>{currentPage + "/" + totalPages + " Pages"}</div>}
    </>
  );
};

export default PaginationFooterRising;
